import { authApiClient } from '~/lib/api-client'

export interface FixtureCandidateRow {
  id: string
  polymarketEventId: string
  polymarketEventTitle: string
  polymarketEventStartTime: string | null
  polymarketHomeTeam: string | null
  polymarketAwayTeam: string | null
  footballFixtureId: string
  apiSportsFixtureId: number
  footballHomeTeam: string
  footballAwayTeam: string
  footballFixtureStartTime: string
  confidenceScore: number
  matchingSignals: {
    timeDifferenceHours: number
    homeTeamSimilarity: number
    awayTeamSimilarity: number
    competitionMatch: boolean
  }
  status: 'pending' | 'dismissed' | 'approved'
  reviewedAt: string | null
  createdAt: string
}

export interface FixtureCandidatesListResponse {
  items: FixtureCandidateRow[]
  pagination: {
    page: number
    pageSize: number
    total: number
    totalPages: number
  }
}

const mappingCandidatesClient = (authApiClient as any).api.admin['mapping-candidates']

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let message = `Request failed with status ${response.status}`
    try {
      const body = await response.json() as { message?: string, error?: { message?: string, issues?: Array<{ message?: string }> } }
      message = body.message ?? body.error?.message ?? body.error?.issues?.[0]?.message ?? message
    }
    catch {
      // Fallback
    }
    throw new Error(message)
  }
  return response.json() as Promise<T>
}

export async function listMappingCandidates(query: {
  status: 'pending' | 'dismissed' | 'approved'
  page: number
  pageSize: number
  minScore?: number
  competitionCode?: string
  season?: number
}) {
  const response = await mappingCandidatesClient.$get({
    query: {
      status: query.status,
      page: String(query.page),
      pageSize: String(query.pageSize),
      ...(query.minScore !== undefined ? { minScore: String(query.minScore) } : {}),
      ...(query.competitionCode && query.season
        ? { competitionCode: query.competitionCode, season: String(query.season) }
        : {}),
    },
    header: { Authorization: '' },
  })
  return parseJson<FixtureCandidatesListResponse>(response)
}

export async function batchActionMappingCandidates(input: {
  candidateIds: string[]
  action: 'approve' | 'dismiss'
  competitionCode: string
  season: number
}) {
  const response = await mappingCandidatesClient.batch.$post({
    json: input,
    header: { Authorization: '' },
  })
  return parseJson<{ success: boolean, count: number }>(response)
}

export async function undoActionMappingCandidates(input: {
  candidateIds: string[]
  action: 'approve' | 'dismiss'
  competitionCode: string
  season: number
}) {
  const response = await mappingCandidatesClient.undo.$post({
    json: input,
    header: { Authorization: '' },
  })
  return parseJson<{ success: boolean, undoneIds: string[] }>(response)
}
